import React from "react";
import RadioGroup from "@ui-components/RadioGroup";
import Alert from "@ui-components/Alert";
import Checkbox from "@ui-components/Checkbox";
import {FormattedMessage, useIntl} from "react-intl";
import {PRIVILEGED_ROLES} from "../../constants";

const VisibilityEditor = ({
  labelKey,
  publicLabelKey,
  choice,
  setChoice,
  users,
  visibility,
  setVisibility,
  sharing,
  excludedRoles = [...PRIVILEGED_ROLES, 'sales_director', 'area_manager']
}) => {

  // hooks
  const intl = useIntl();

  const usersToShow = users
    .filter(user => !excludedRoles.includes(user.role) || sharing.find(u => u.to_user_id === user.id))
    .sort((a, b) => a.name.localeCompare(b.name))
    .map(u => u);


  return (
    <div className="flex flex-col my-4">
      <div>
        {intl.formatMessage({id: labelKey || "visibility"})}
      </div>
      <RadioGroup
        options={[
          {value: "public", name: intl.formatMessage({id: publicLabelKey || "public"})},
          {value: "manage_visibility", name: intl.formatMessage({id: "manage_visibility"})},
        ]}
        currentValue={choice}
        onChange={setChoice}
      />
      {
        choice === "manage_visibility" && (
          <div className="flex flex-col gap-2 mt-4 text-xs">
            <div className={"grid grid-cols-1 border divide-y divide-gray-400"}>
              {
                usersToShow.length > 0 ?
                  usersToShow.map((user, index) => (
                    <div
                      key={index}
                      className={`p-2 grid grid-cols-2 items-center ${index % 2 === 1 ? "bg-white" : "bg-gray-100"}`}
                    >
                      <div className={"grid grid-cols-8 items-center"}>
                        <div className={"justify-center"}>
                          <Checkbox
                            checked={visibility.map(u=>u.id).includes(user.id)}
                            onChange={(e) => {
                              if (e.target.checked) {
                                setVisibility([...visibility, {id:user.id, flg_internal: user.flg_internal}])
                              } else {
                                setVisibility(visibility.filter(u => u.id !== user.id))
                              }
                            }}
                          />
                        </div>
                        <span className={"ml-1 col-span-7 font-semibold"}>
												{user.name}
											</span>
                      </div>
                      <span>
											<FormattedMessage id={`user_type_${user.role}`}/>
										</span>
                    </div>
                  )):
                  <Alert
                    type="info"
                    text={intl.formatMessage({id: "no_users_to_show"})}
                  />
              }
            </div>
          </div>
        )
      }
    </div>
  )
}

export default VisibilityEditor;